"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FreeShipping_1 = __importDefault(require("../../../icons/FreeShipping"));
var GreatDealTag_1 = __importDefault(require("../../../icons/GreatDealTag"));
var NewPrice_1 = __importDefault(require("../../../icons/NewPrice"));
var PricingArrow_1 = __importDefault(require("../../../icons/PricingArrow"));
var SolidPlugIcon_1 = __importDefault(require("../../../icons/SolidPlugIcon"));
var utils_1 = require("../../../utils");
function recommendedSearches(isRestrictedState) {
    return [
        {
            text: 'Shop Great Deals',
            icon: react_1.default.createElement(GreatDealTag_1.default, null),
            filters: { tagIds: ['104'] }
        },
        {
            text: isRestrictedState ? 'New Prices' : 'Price Drops',
            icon: isRestrictedState ? react_1.default.createElement(NewPrice_1.default, null) : react_1.default.createElement(PricingArrow_1.default, null),
            filters: { tagIds: ['103'] }
        },
        {
            text: 'Free Shipping',
            icon: react_1.default.createElement(FreeShipping_1.default, null),
            filters: { isFreeDelivery: true }
        },
        {
            text: 'EV Tax Credit Eligible',
            icon: react_1.default.createElement(SolidPlugIcon_1.default, null),
            filters: { tagIds: ['116'] }
        },
        {
            text: 'Cars Under $20,000',
            filters: { price: { min: 7990, max: 20000 } }
        },
        {
            text: "Delivery by ".concat((0, utils_1.getWeekDay)(4)),
            filters: {
                earliestDayToDeliveryOrPickup: {
                    days: 4,
                    pickupAndDeliveryOption: 'pickupAndDelivery'
                }
            }
        }
    ];
}
exports.default = recommendedSearches;
//# sourceMappingURL=recommendedSearchesList.js.map